







import { Component, Vue, Prop } from 'vue-property-decorator'; // デコレータ
import router from '../router';
import axios from 'axios';
import { uketsukeManagementModule } from './store/modules/UketsukeManger';
import { supervisingModule } from '../store/modules/OperationSupervising';
import { ScreenName } from '@/CommonUtils/fixed/ScreenName';
import { Constants } from '../CommonUtils/fixed/Constants';
import { UketsukeScreenName } from './fixed/UketsukeScreenName';

@Component
export default class Uketsuke extends Vue {
}
